import React, { useLayoutEffect } from 'react';
import { Navigate } from 'react-router-dom';
import UIActions from '../../ui/UIActions';
import useAppSelector, { useAppDispatch } from '../redux/useAppSelector';
import EnsureLoggedIn from './EnsureLoggedIn';

interface EnsureAdminProps {
  children: JSX.Element;
}

const EnsureAdmin = ({ children }: EnsureAdminProps) => {
  const { id, type } = useAppSelector((state) => state.session.user);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    if (id && type !== 'ADMIN') {
      dispatch(
        UIActions.pushToast({
          level: 'warning',
          message: 'Must be an admin to do that.',
        }),
      );
    }
  }, [dispatch, id, type]);

  if (!id) return <EnsureLoggedIn />;

  if (type !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default EnsureAdmin;
